<template>
  <div>
    <section-page
      title="Default Seller Contact Type"
      description="This contact type will be added to all contacts that are created with leads."
      is-short
    >
      <form-field-select
        v-model="defaultSellerContactType"
        class="mb-100"
      >
        <option
          v-for="types in sellerTypes"
          :value="types.id"
          :key="types.id"
        >{{ types.name }}
        </option>
      </form-field-select>
    </section-page>

    <section-page
      title="Contact Types"
      description="Contact Types allow you to add custom fields to certain types of contacts."
    >
      <template v-slot:right>
        <button-outlined icon-left="plus" @click="$refs.typeAddModal.open()">
          New Type
        </button-outlined>
      </template>

      <app-empty-message
        :count="types.length"
        heading="You don't have any tags. Why don't you make one."
      >
        <table-default
          :table-data="types"
          default-sort="label"
        >
          <b-table-column label="Name" field="name" sortable v-slot="props">
            {{ props.row.name }}
          </b-table-column>

          <b-table-column label="Type" field="type" sortable v-slot="props">
            {{ props.row.type | newEnumLabel(ENUMS.ContactTypeEnum) }}
          </b-table-column>

          <b-table-column label="Custom Fields" v-slot="props">
            {{ getCustomFieldList(props.row.id) }}
          </b-table-column>

          <b-table-column cell-class="action_cell" width="120" v-slot="props">
            <button-link @click="editType(props.row)">Manage</button-link>
          </b-table-column>
        </table-default>
      </app-empty-message>

      <modal-container>
        <modal-crud-form
          ref="typeAddModal"
          title="Contact Type"
          form-component="contact-type-form">
        </modal-crud-form>

        <modal-form-edit
          ref="typeEditModal"
          title="Contact Type"
          form-component="contact-type-form"
        >
          <contact-type-custom-fields :contact-type="contactType"></contact-type-custom-fields>
        </modal-form-edit>
      </modal-container>
    </section-page>
  </div>
</template>

<script>
import ContactTypeCustomFields from "./ContactTypeCustomFields";
import {ENUMS} from "../../../services/enums";
import api from "../../../api";

export default {
  name: "ContactTypes",
  components: {ContactTypeCustomFields},
  data() {
    return {
      contactType: null,
    }
  },
  computed: {
    types() {
      return this.$store.getters.contactTypes;
    },
    defaultSellerContactType: {
      get() {
        return this.$store.getters.account.default_seller_contact_type_id
      },
      set(newValue) {
        api.accounts.changeDefaultContactType({
          default_seller_contact_type_id: newValue
        })
      }
    },
    sellerTypes() {
      return this.types.filter(type => type.type === ENUMS.ContactTypeEnum.Seller.value)
    }
  },
  methods: {
    getCustomFieldList(contactTypeId) {
      const fields = this.$store.getters.customFields(ENUMS.CustomFieldableTypeEnum.ContactType.value, contactTypeId);
      let fieldString = '';

      fields.forEach(field => {
        fieldString += field.label + ', ';
      });

      return fieldString.trim().slice(0, -1);
    },
    editType(contactType) {
      this.contactType = contactType;
      this.$refs.typeEditModal.open(contactType);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
